import createPersistedState from "vuex-persistedstate"
import { createStore } from 'vuex'
import Basic from "./modules/basic"
import View from "./modules/view"

export default createStore({
    modules: {
        basic: Basic,
        view: View,
    },
    plugins: [createPersistedState({
        paths: ["basic", "view"]
    })]
})
